import React from "react";
export var Environment;
(function (Environment) {
    Environment["PRODUCTION"] = "production";
    Environment["STAGING"] = "staging";
    Environment["DEV"] = "dev";
})(Environment || (Environment = {}));
const noop = () => {
    if (process.env.NODE_ENV !== "test") {
        console.warn("Failed to get context. Make sure you wrap your application with <DomainProvider>");
    }
};
const defaultContext = {
    getApplicationByUrl: noop,
    getApplicationIdByUrl: noop,
    isExternalUrl: noop,
};
export default React.createContext(defaultContext);
